(function () {
  function qsa(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function setupCountdowns() {
    qsa('[data-countdown-minutes]').forEach(function (countdown) {
      if (countdown.dataset.ready === 'true') return;
      countdown.dataset.ready = 'true';

      var display = countdown.querySelector('[data-countdown-display]');
      var minutes = parseInt(countdown.getAttribute('data-countdown-minutes') || '15', 10);
      var secondsLeft = Math.max(1, minutes) * 60;

      function render() {
        var minutesLeft = Math.floor(secondsLeft / 60);
        var seconds = secondsLeft % 60;
        if (display) {
          display.textContent = String(minutesLeft).padStart(2, '0') + ':' + String(seconds).padStart(2, '0');
        }
      }

      render();
      setInterval(function () {
        secondsLeft = Math.max(0, secondsLeft - 1);
        render();
      }, 1000);
    });
  }

  function setupReveal() {
    var items = qsa('.bm-reveal');
    if (!items.length) return;

    if (!('IntersectionObserver' in window)) {
      items.forEach(function (item) { item.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.14 });

    items.forEach(function (item) { observer.observe(item); });
  }

  function setupStickyBuy() {
    var sticky = document.querySelector('.bm-sticky-buy');
    var page = document.querySelector('.bm-product-page');
    if (!sticky || !page) return;

    function update() {
      var scrollable = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
      var progress = window.scrollY / scrollable;
      sticky.classList.toggle('is-active', progress >= 0.35);
    }

    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
  }

  function setupCartQuantity() {
    qsa('[data-cart-qty]').forEach(function (wrap) {
      if (wrap.dataset.ready === 'true') return;
      wrap.dataset.ready = 'true';

      var input = wrap.querySelector('input');
      var minus = wrap.querySelector('[data-cart-minus]');
      var plus = wrap.querySelector('[data-cart-plus]');
      if (!input) return;

      function submitCart() {
        var form = wrap.closest('form');
        var updateButton = form && form.querySelector('.bm-update-cart');
        if (!form) return;
        if (form.requestSubmit) {
          form.requestSubmit(updateButton || undefined);
        } else {
          form.submit();
        }
      }

      if (minus) {
        minus.addEventListener('click', function () {
          input.value = Math.max(0, parseInt(input.value || '1', 10) - 1);
          submitCart();
        });
      }

      if (plus) {
        plus.addEventListener('click', function () {
          input.value = Math.max(1, parseInt(input.value || '1', 10) + 1);
          submitCart();
        });
      }

      input.addEventListener('change', function () {
        input.value = Math.max(0, parseInt(input.value || '0', 10));
        submitCart();
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    setupCountdowns();
    setupReveal();
    setupStickyBuy();
    setupCartQuantity();
  });
})();
